import React, { useState, useEffect } from "react";
import {
  Button,
  Grid,
  TextField,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tabs,
  Tab,
  FormLabel,
  CircularProgress,
  Checkbox,
  Avatar,
  IconButton,
  Tooltip
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import { Card, Stack, Container, Typography } from "@mui/material";
// components
import Page from "../components/Page";
import Label from "../components/Label";

import moment from "moment";
import {
  generateMemberInvoiceApi,
  getMemberInvoiceDetailsApi,
  sendInvoiceOtpToMobileApi,
  validateInvoiceLinkApi,
  fetchGstDetailsbynumberApi,
  generateMemberInvoiceFromAdminApi
} from "src/api/invoiceApi";
import { notification } from "src/utils/messages";
import { Routes } from "../constant/api_url";
import { featchleadhistory, handleDownload } from "src/utils/common";
import { LocalPhone, Person } from "@mui/icons-material";
import { decryptMyData } from "src/constant/variable";
import CloseIcon from "@mui/icons-material/Close";

// ----------------------------------------------------------------------

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 720,
  margin: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "30px 0"
}));

const LoginFormCard = {
  padding: "15px",
  margin: "auto",
  display: "block",
  width: "100%"
};

const Login_body = {
  margin: "15px 15px 15px 0",
  maxHeight: "calc(100vh - 250px)",
  overflowY: "auto",
  overflowX: "hidden",
  paddingLeft: "15px"
};

const form_title = {
  margin: "15px 0",
  textAlign: "center"
};
// ----------------------------------------------------------------------

export default function InvoiceDownloadForm({
  setGenerateInvoiceModal,
  generateInvoiceModal,
  leadDetails = {},
  setLeadHistory = () => { },
  type = "",
  setIsInvoiceGenerated = () => { }
}) {
  let { c_id } = useParams();
  const navigate = useNavigate();

  let City_amb_id = 1;
  let p_u_id = 0;
  let date = moment().format("DD-MM-YYYY");

  if (c_id != undefined) {
    City_amb_id = Buffer.from(c_id, "base64").toString("ascii");
    p_u_id = 1;
  }

  const [formData, setFormData] = useState({
    // Mail Id
    lead_id: "",
    l_created_by: City_amb_id,
    l_allocated_to: City_amb_id,
    p_u_id: p_u_id,
    l_type: 3,
    l_phase: 3,
    date: date,
    c_f: true,
    from_l_phase: "",

    // Step 1
    name: "",
    dob: "",
    l_contact_no: "",
    alternate_contact_number: "",
    insuranceType: [],
    otherInsurance: "",
    aadhaar: "",
    facebook_url: "",
    instagram_url: "",

    // Step 2
    l_business_name: "",
    gst_business_name: "",
    gst_business_address: "",
    l_business_category: "",
    l_business_description: "",
    gst_no: "",
    l_email: "",
    l_address: "", // office address
    l_h_address: "", // home address
    payment_date: "",
    payment_mode: 0,
    l_professional_photo: "",
    // l_product_photo: "",
    l_payment_photo: [],
    l_reference_1: "",
    l_reference_2: "",

    //
    updateby_member: 0,
    verify_otp: "",
    is_edit_form: 0,
    gst_type: 0
  });
  const [activeTab, setActiveTab] = useState(generateInvoiceModal ? 1 : 3);
  const [otpSent, setOtpSent] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isMember, setIsMember] = useState(false);
  const [invalidLinkData, setInvalidLinkData] = useState({});
  const [invoiceDetails, setInvoiceDetails] = useState({});
  const [originalGstBusinessName, setOriginalGstBusinessName] = useState("");

  const initialErrorState = {
    // Step 1
    name: "",
    dob: "",
    l_contact_no: "",
    alternate_contact_number: "",
    insuranceType: "",
    aadhaar: "",
    facebook_url: "",
    instagram_url: "",
    gst_no: "",

    // Step 2
    l_business_name: "",
    l_business_category: "",
    l_email: "",
    l_address: "",
    l_h_address: "",
    payment_date: "",
    payment_mode: "",
    l_professional_photo: "",
    // l_product_photo: "",
    l_payment_photo: "",
    l_reference_1: "",
    l_reference_2: ""
  };

  const [errors, setErrors] = useState(initialErrorState);

  const onChangeFunction = (e) => {
    const { name, value } = e.target;
    if (name === "gst_type" && value != "1") {
      setFormData({
        ...formData,
        [name]: value,
        gst_no: "",
        gst_business_name: "",
        gst_business_address: ""
      });
      setOriginalGstBusinessName("");
      setErrors((prev) => ({ ...prev, gst_no: "" }));
    } else if (name === "gst_no") {
      setFormData({
        ...formData,
        [name]: value,
        gst_business_name: "",
        gst_business_address: ""
      });
      setOriginalGstBusinessName("");
    } else {
      setFormData({ ...formData, [name]: value });
    }

    // Clear OTP error on typing
    if (name === "verify_otp") setOtpError("");
  };

  const sendInvoiceOtpToMobile = async () => {
    if (!formData.l_contact_no || !/^[0-9]{10}$/.test(formData.l_contact_no)) {
      setErrors((prev) => ({
        ...prev,
        l_contact_no: "Enter Only 10 digits allowed. Do not add +91 or characters."
      }));
      return;
    }

    setErrors((prev) => ({
      ...prev,
      l_contact_no: ""
    }));

    const response = await sendInvoiceOtpToMobileApi({
      mobile: formData.l_contact_no,
      lead_id: parseInt(atob(window.location.pathname.split("/").pop()))
    });

    if (response.status === 1 && response.otp) {
      const otpData = decryptMyData(response.otp);
      localStorage.setItem("customer_otp", otpData.code); // Store OTP
      setOtpSent(true);
      setOtpError("");

      notification({
        type: "success",
        message: "OTP sent successfully. Please check your mobile."
      })();
    } else {
      notification({
        type: "error",
        message: response.message
      })();
    }
  };

  const verifyOtp = async () => {
    if (!formData.verify_otp || formData.verify_otp.length !== 6) {
      setOtpError("Enter a valid 6-digit OTP.");
      return;
    }

    const localOtp = localStorage.getItem("customer_otp");

    if (formData.verify_otp === localOtp) {
      // Clear error and move forward
      setOtpError("");
      notification({
        type: "success",
        message: "Your OTP has been verified. Proceeding to the next step."
      })();

      setFormData((prev) => ({ ...prev, otp_verified: true }));
      getMemberInvoiceDetails();
      setActiveTab(1);
      localStorage.removeItem("customer_otp");
    } else {
      setOtpError("Incorrect OTP. Please try again.");
    }
  };

  const validateInvoiceLink = async () => {
    const resp = await validateInvoiceLinkApi({ form_url: new URL(window.location.href).pathname });

    if (resp.status == 0) {
      if (resp?.data?.invalid_url == 0) {
        setIsMember(true);
        setInvalidLinkData(resp?.data);
      } else navigate("/404");
    }
  };

  const getMemberInvoiceDetails = async () => {
    let id = generateInvoiceModal
      ? leadDetails?.lead_id || leadDetails?.m_id
      : parseInt(atob(window.location.pathname.split("/").pop()));
    const payload = type === "member" ? { m_id: id } : { lead_id: id };

    const resp = await getMemberInvoiceDetailsApi(payload);

    if (resp.status == 1) {
      if (resp?.data?.invoice_url) {
        setIsMember(true);
        setInvalidLinkData(resp?.data);
      } else {
        setInvoiceDetails(resp?.data);
        setFormData((prev) => ({
          ...prev,
          l_business_name: resp?.data?.l_business_name || "",
          l_address: resp?.data?.l_address || "",
          gst_business_name: resp?.data?.gst_business_name || "",
          gst_business_address: resp?.data?.gst_business_address || "",
          gst_type: resp?.data?.gst_no ? 1 : 0,
          gst_no: resp?.data?.gst_no || ""
        }));
        setOriginalGstBusinessName(resp?.data?.gst_business_name || "");

        if (resp?.data?.gst_no) {
          try {
            const gstResp = await fetchGstDetailsbynumberApi({ gst_no: resp.data.gst_no });
            if (gstResp.status === 1) {
              setOriginalGstBusinessName(gstResp.data?.business_name || "");
            }
          } catch (e) {
            console.error("Failed to fetch initial GST details", e);
          }
        }
      }
    }

    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
  };

  const fetchGstDetailsbynumber = async (gst_no) => {
    try {
      const response = await fetchGstDetailsbynumberApi({ gst_no: gst_no });

      if (response.status === 1) {
        const busName = response.data.business_name || "";
        setFormData((prev) => ({
          ...prev,
          // l_business_name: busName,
          // l_address: response.data.address,
          gst_business_name: busName,
          gst_business_address: response.data.address
        }));
        setOriginalGstBusinessName(busName);
        notification({
          type: "success",
          message: response.message
        })();
        setErrors({
          ...errors,
          gst_no: validateGST(formData?.gst_no)
        });
      } else {
        notification({
          type: "error",
          message: response.message
        })();
      }
    } catch (error) {
      notification({
        type: "error",
        message: "Failed to fetch GST details"
      })();
    }
  };

  const generateMemberInvoice = async () => {
    if (formData?.gst_type == 1 && validateGST(formData?.gst_no)?.length > 0) {
      setErrors({
        ...errors,
        gst_no: validateGST(formData?.gst_no)
      });
      return;
    }

    setIsLoading(true);

    let id = generateInvoiceModal
      ? leadDetails?.lead_id || leadDetails?.m_id
      : parseInt(atob(window.location.pathname.split("/").pop()));
    const payloadId = type === "member" ? { m_id: id } : { lead_id: id };

    const resp = type === "member" || type === "lead" ? await generateMemberInvoiceFromAdminApi({
      ...payloadId,
      gst_type: parseInt(formData.gst_type),
      gst_no: formData.gst_type == 1 ? formData?.gst_no : "",
      business_name:
        formData.gst_type == 1
          ? formData?.gst_business_name || formData?.l_business_name
          : formData?.l_business_name || invoiceDetails?.l_business_name,
      address:
        formData.gst_type == 1
          ? formData?.gst_business_address || formData?.l_address
          : formData?.l_address || invoiceDetails?.l_address
    }) : await generateMemberInvoiceApi({
      ...payloadId,
      gst_type: parseInt(formData.gst_type),
      gst_no: formData.gst_type == 1 ? formData?.gst_no : "",
      business_name:
        formData.gst_type == 1
          ? formData?.gst_business_name || formData?.l_business_name
          : formData?.l_business_name || invoiceDetails?.l_business_name,
      address:
        formData.gst_type == 1
          ? formData?.gst_business_address || formData?.l_address
          : formData?.l_address || invoiceDetails?.l_address
    });

    setIsLoading(false);

    if (resp.status == 1) {
      setIsMember(true);
      setInvalidLinkData(resp?.data);
      if (generateInvoiceModal && type !== "member")
        setLeadHistory(await featchleadhistory(leadDetails?.lead_id));
      if (generateInvoiceModal && type === "member") setIsInvoiceGenerated(true);
    }

    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
  };

  const validateGST = (value) => {
    if (!value || value.trim() === "") {
      return "GST number is required";
    }

    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/;

    if (!gstRegex.test(value)) {
      return "Enter valid GST number";
    }

    return "";
  };

  useEffect(() => {
    if (generateInvoiceModal) getMemberInvoiceDetails();
    else validateInvoiceLink();
  }, []);

  return (
    <>
      <Page title={
        "Invoice Download | Local Vocal Business Group"
      }>
        <Container>
          <ContentStyle style={{ alignItems: "center", padding: "0", maxWidth: "780px" }}>
            {isMember === true ? (
              <Box
                sx={{
                  minHeight: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <Card
                  sx={{
                    maxWidth: 600,
                    p: 4,
                    boxShadow:
                      "0px 3px 3px 3px rgba(145, 158, 171, 0.2), 0px 3px 4px 0px rgba(145, 158, 171, 0.14), 0px 1px 8px 0px rgba(145, 158, 171, 0.12)",
                    borderRadius: 3,
                    backgroundColor: "#fefefe"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center"
                    }}
                  >
                    <Box
                      component="img"
                      // src={Routes.API_HOSTNAME + "logo/LVB-Logo.png"}
                      src={Routes.API_HOSTNAME + "logo/LVB-PRIVILEGE-LOGO.png"}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/static/logo/LVB-PRIVILEGE-LOGO.png";
                      }}
                      alt="LVB Logo"
                      sx={{ height: 80, mb: 2 }}
                    />
                    {generateInvoiceModal && (
                      <Tooltip title="Close">
                        <IconButton
                          onClick={() => {
                            setGenerateInvoiceModal(false);
                          }}
                          sx={{
                            position: "absolute",
                            right: 10,
                            top: 10

                            // boxShadow: "0 3px 10px rgba(211, 47, 47, 0.3)"
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    )}

                    <Avatar
                      sx={{
                        bgcolor: "primary.main",
                        width: 56,
                        height: 56,
                        mb: 2,
                        mt: 3
                      }}
                    >
                      <Person sx={{ fontSize: 32 }} />
                    </Avatar>
                    <Typography variant="h5" gutterBottom color="primary">
                      {invalidLinkData?.title}
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1, mb: 2 }}>
                      {invalidLinkData?.body}
                    </Typography>
                    {invalidLinkData?.invoice_url ? (
                      invalidLinkData?.i_generate_date && (
                        <div
                          style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: "bold", marginRight: "10px" }}
                          >
                            Invoice Generate Date:{" "}
                            {moment(invalidLinkData?.i_generate_date).format("DD-MM-YYYY")}
                          </Typography>
                        </div>
                      )
                    ) : (
                      invalidLinkData?.invoice_expiry_date && (
                        <div
                          style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: "bold", marginRight: "10px" }}
                          >
                            Invoice Expiry Date:{" "}
                            {invalidLinkData?.invoice_expiry_date}
                          </Typography>
                          {(() => {
                            const days = moment(invalidLinkData?.invoice_expiry_date, "DD-MM-YYYY")
                              .startOf("day")
                              .diff(moment().startOf("day"), "days");
                            return (
                              <Label color={days < 0 ? "error" : "success"}>
                                {days > 0
                                  ? `${days} days left`
                                  : days < 0
                                    ? `Expired by ${Math.abs(days)} days`
                                    : `Expires today`}
                              </Label>
                            );
                          })()}
                        </div>
                      )
                    )}
                    {invalidLinkData?.invoice_url && (

                      <Button
                        variant="contained"
                        onClick={async () => {
                          handleDownload(
                            `${Routes.API_HOSTNAME}invoice-pdf/${invalidLinkData?.invoice_url}`,
                            invalidLinkData?.invoice_url
                          );
                        }}
                        disabled={isLoading}
                      >
                        Download Invoice{" "}
                        {isLoading && (
                          <CircularProgress size={14} color="inherit" sx={{ marginLeft: "10px" }} />
                        )}
                      </Button>
                    )}
                  </Box>
                </Card>
              </Box>
            ) : (
              <Box
                sx={{
                  minHeight: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%"
                }}
              >
                <Card className="LoginFormCard" style={LoginFormCard}>
                  <Box
                    component="img"
                    src={Routes.API_HOSTNAME + "logo/LVB-PRIVILEGE-LOGO.png"}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/static/logo/LVB-PRIVILEGE-LOGO.png";
                    }}
                    sx={{ display: "block", margin: "auto", height: "100px" }}
                  />
                  {generateInvoiceModal && (
                    <Tooltip title="Close">
                      <IconButton
                        onClick={() => {
                          setGenerateInvoiceModal(false);
                        }}
                        sx={{
                          position: "absolute",
                          right: 10,
                          top: 10
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                  {!generateInvoiceModal && (
                    <h4 className="form_title" style={form_title}>
                      Generate Your Membership Invoice
                    </h4>
                  )}

                  <div className="Login_body" style={Login_body}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <Tabs
                        value={activeTab}
                        variant="fullWidth"
                        allowScrollButtonsMobile
                        onChange={(e, value) => {
                          // Prevent changing tab unless allowed
                          if (value === 1 && !formData?.otp_verified) return; // Personal locked until OTP
                          setActiveTab(value);
                        }}
                      >
                        {!generateInvoiceModal && (
                          <Tab
                            style={{ marginBottom: "0", paddingBottom: "0", cursor: "auto" }}
                            disableRipple
                            key={3}
                            value={3}
                            label="Mobile Number Verify"
                            icon={<LocalPhone />}
                            iconPosition="start"
                            disabled={formData?.otp_verified}
                          />
                        )}
                        <Tab
                          style={{ marginBottom: "0", paddingBottom: "0", cursor: "auto" }}
                          disableRipple
                          key={1}
                          value={1}
                          label="Invoice Details"
                          icon={<Person />}
                          iconPosition="start"
                          disabled={!formData?.otp_verified}
                        />
                      </Tabs>
                    </Box>

                    <Grid
                      container
                      spacing={1.5}
                      style={{ marginTop: "15px" }}
                      alignItems="stretch"
                    >
                      {activeTab == 3 ? (
                        <>
                          <Grid
                            container
                            spacing={1.5}
                            style={{ marginTop: "15px", justifyContent: "center" }}
                          >
                            <Grid item xs={12} md={8}>
                              <Stack spacing={2} style={{ marginBottom: "7px" }}>
                                <TextField
                                  fullWidth
                                  required
                                  label="Contact Number"
                                  name="l_contact_no"
                                  inputProps={{ maxLength: 10 }}
                                  margin="dense"
                                  disabled={otpSent}
                                  value={formData?.l_contact_no || ""}
                                  onChange={(e) => {
                                    // Remove all spaces from the input

                                    const value = e.target.value.replace(/\D/g, ""); // remove non-digits

                                    onChangeFunction({
                                      target: {
                                        name: "l_contact_no",
                                        value: value
                                      }
                                    });
                                  }}
                                  error={!!errors.l_contact_no}
                                  helperText={errors.l_contact_no}
                                />
                                <span
                                  style={{ fontSize: "13px", color: "orange", marginTop: "3px" }}
                                >
                                  Only 10 digits allowed. Do not add +91 or characters or blank
                                  space.
                                </span>

                                {!otpSent && (
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={formData?.acceptTerms || false}
                                        onChange={(e) =>
                                          onChangeFunction({
                                            target: {
                                              name: "acceptTerms",
                                              value: e.target.checked
                                            }
                                          })
                                        }
                                      />
                                    }
                                    label={
                                      <span>
                                        I accept the Invoice Instruction and{" "}
                                        <a
                                          href="https://lvb-india.com/lvb-india-invoice-generation-policy"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{ color: "#034766" }}
                                        >
                                          <b>Terms & Conditions</b>
                                        </a>
                                        .
                                      </span>
                                    }
                                  />
                                )}
                              </Stack>
                            </Grid>

                            {otpSent && (
                              <Grid item xs={12} md={8}>
                                <Stack spacing={2} style={{ marginBottom: "15px" }}>
                                  <TextField
                                    fullWidth
                                    required
                                    label="Enter OTP"
                                    name="verify_otp"
                                    value={formData.verify_otp || ""}
                                    onChange={onChangeFunction}
                                    helperText={otpError}
                                    error={otpError !== ""}
                                  />
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={formData?.acceptTerms || false}
                                        disabled={otpSent}
                                        onChange={(e) =>
                                          onChangeFunction({
                                            target: {
                                              name: "acceptTerms",
                                              value: e.target.checked
                                            }
                                          })
                                        }
                                      />
                                    }
                                    label={
                                      <span>
                                        I accept the Invoice Instruction and{" "}
                                        <a
                                          href="https://lvb-india.com/lvb-india-invoice-generation-policy"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{ color: "#034766" }}
                                        >
                                          <b>Terms & Conditions</b>
                                        </a>
                                        .
                                      </span>
                                    }
                                  />
                                </Stack>
                              </Grid>
                            )}
                            <Grid item xs={12} md={8}>
                              <Stack spacing={2} style={{ marginBottom: "15px" }}>
                                {otpSent ? (
                                  <Button variant="contained" onClick={verifyOtp}>
                                    Verify OTP
                                  </Button>
                                ) : (
                                  <Button
                                    variant="contained"
                                    onClick={async (e) => {
                                      sendInvoiceOtpToMobile();
                                    }}
                                    disabled={
                                      !formData.l_contact_no || // no number
                                      !/^[0-9]{10}$/.test(formData.l_contact_no) || // invalid number
                                      !formData.acceptTerms // terms not accepted
                                    }
                                  >
                                    Send OTP
                                  </Button>
                                )}
                              </Stack>
                            </Grid>
                          </Grid>
                        </>
                      ) : activeTab == 1 ? (
                        <>
                          <Grid
                            container
                            spacing={1}
                            style={{ marginTop: "10px", marginLeft: "0px", marginRight: "0px" }}
                          >
                            {/* Left Column */}
                            <Grid item xs={12} sm={6}>
                              <Stack spacing={1}>
                                {/* Full Name */}
                                <Box>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontWeight: 500,
                                      display: "block",
                                      mb: 0.5
                                    }}
                                  >
                                    Full Name
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontSize: "14px",
                                      color: "#333",
                                      fontWeight: 500,
                                      pb: 1.5
                                      // borderBottom: "1px solid #e0e0e0"
                                    }}
                                  >
                                    {invoiceDetails?.name || "-"}
                                  </Typography>
                                </Box>

                                {/* Email ID */}
                                <Box>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontWeight: 500,
                                      display: "block",
                                      mb: 0.5
                                    }}
                                  >
                                    Email ID
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontSize: "14px",
                                      color: "#333",
                                      fontWeight: 500,
                                      pb: 1.5,
                                      // borderBottom: "1px solid #e0e0e0",
                                      wordBreak: "break-word"
                                    }}
                                  >
                                    {invoiceDetails?.l_email || "-"}
                                  </Typography>
                                </Box>

                                {/* Payment Method */}
                                <Box>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontWeight: 500,
                                      display: "block",
                                      mb: 0.5
                                    }}
                                  >
                                    Payment Method
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontSize: "14px",
                                      color: "#333",
                                      fontWeight: 500,
                                      pb: 1.5
                                      // borderBottom: "1px solid #e0e0e0"
                                    }}
                                  >
                                    {invoiceDetails?.payment_mode == 0
                                      ? "Cash"
                                      : invoiceDetails?.payment_mode == 1
                                        ? "Transfer"
                                        : invoiceDetails?.payment_mode == 2
                                          ? "Cheque"
                                          : "-"}
                                  </Typography>
                                </Box>

                                {/* GST Question */}
                                <Box>
                                  <FormLabel
                                    sx={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontWeight: 500,
                                      display: "block",
                                      mb: 1
                                    }}
                                  >
                                    Do You Want GST invoice?
                                  </FormLabel>
                                  <RadioGroup
                                    row
                                    value={formData.gst_type}
                                    onChange={onChangeFunction}
                                    name="gst_type"
                                  >
                                    <FormControlLabel
                                      value="1"
                                      control={<Radio size="small" />}
                                      label="Yes"
                                    />
                                    <FormControlLabel
                                      value="0"
                                      control={<Radio size="small" />}
                                      label="No"
                                    />
                                  </RadioGroup>
                                </Box>
                              </Stack>
                            </Grid>

                            {/* Right Column */}
                            <Grid item xs={12} sm={6}>
                              <Stack spacing={1}>
                                {/* <Box>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontWeight: 500,
                                      display: "block",
                                      mb: 0.5
                                    }}
                                  >
                                    Company Name
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontSize: "14px",
                                      color: "#333",
                                      fontWeight: 500,
                                      pb: 1.5,
                                      // borderBottom: "1px solid #e0e0e0",
                                      wordBreak: "break-word"
                                    }}
                                  >
                                    {formData.gst_type == 1
                                      ? formData?.l_business_name || "-"
                                      : invoiceDetails?.l_business_name || "-"}
                                  </Typography>
                                </Box> */}
                                <TextField
                                  fullWidth
                                  autoComplete="off"
                                  type="text"
                                  label={formData.gst_type == 1 ? "Business Name (As Per GST)" : "Company Name"}
                                  name={formData.gst_type == 1 ? "gst_business_name" : "l_business_name"}
                                  value={formData.gst_type == 1 ? formData?.gst_business_name || "" : formData?.l_business_name || ""}
                                  onChange={onChangeFunction}
                                  onBlur={(e) => errors.l_business_name != ""}
                                  helperText={
                                    formData.gst_type == 1 && formData.gst_business_name && originalGstBusinessName && formData.gst_business_name.trim() !== originalGstBusinessName.trim()
                                      ? "business name not matched with GST details"
                                      : errors.l_business_name
                                  }
                                  error={
                                    formData.gst_type == 1 && formData.gst_business_name && originalGstBusinessName && formData.gst_business_name.trim() !== originalGstBusinessName.trim()
                                      ? true
                                      : errors.l_business_name != "" ? true : false
                                  }
                                  size="small"
                                />

                                {/* Invoice Amount */}
                                <Box>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontWeight: 500,
                                      display: "block",
                                      mb: 0.5
                                    }}
                                  >
                                    Invoice Amount
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontSize: "14px",
                                      color: "#333",
                                      fontWeight: 500,
                                      pb: 1.5
                                      // borderBottom: "1px solid #e0e0e0"
                                    }}
                                  >
                                    {invoiceDetails?.invoice_amt || "-"}
                                  </Typography>
                                </Box>

                                {/* Payment Date */}
                                <Box>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontWeight: 500,
                                      display: "block",
                                      mb: 0.5
                                    }}
                                  >
                                    Payment Date
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontSize: "14px",
                                      color: "#333",
                                      fontWeight: 500,
                                      pb: 1.5
                                      // borderBottom: "1px solid #e0e0e0"
                                    }}
                                  >
                                    {invoiceDetails?.payment_date || "-"}
                                  </Typography>
                                </Box>
                                {invoiceDetails?.invoice_url || invoiceDetails?.last_i_id !== 0 ? (
                                  invoiceDetails?.i_generate_date && (
                                    <Box>
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          fontSize: "12px",
                                          color: "#666",
                                          fontWeight: 500,
                                          display: "block",
                                          mb: 0.5
                                        }}
                                      >
                                        Invoice Generate Date
                                      </Typography>
                                      <div style={{ display: "flex", alignItems: "center" }}>
                                        <Typography
                                          variant="body2"
                                          sx={{
                                            fontSize: "14px",
                                            color: "#333",
                                            fontWeight: 500,
                                            marginRight: "10px"
                                          }}
                                        >
                                          {moment(invoiceDetails?.i_generate_date).format(
                                            "DD-MM-YYYY"
                                          )}
                                        </Typography>
                                      </div>
                                    </Box>
                                  )
                                ) : (
                                  invoiceDetails?.invoice_expiry_date && (
                                    <Box>
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          fontSize: "12px",
                                          color: "#666",
                                          fontWeight: 500,
                                          display: "block",
                                          mb: 0.5
                                        }}
                                      >
                                        Invoice Expiry Date
                                      </Typography>
                                      <div style={{ display: "flex", alignItems: "center" }}>
                                        <Typography
                                          variant="body2"
                                          sx={{
                                            fontSize: "14px",
                                            color: "#333",
                                            fontWeight: 500,
                                            marginRight: "10px"
                                          }}
                                        >
                                          {invoiceDetails?.invoice_expiry_date}
                                        </Typography>
                                        {(() => {
                                          const days = moment(invoiceDetails?.invoice_expiry_date, "DD-MM-YYYY")
                                            .startOf("day")
                                            .diff(moment().startOf("day"), "days");
                                          return (
                                            <Label color={days < 0 ? "error" : "success"}>
                                              {days > 0
                                                ? `${days} days left`
                                                : days < 0
                                                  ? `Expired by ${Math.abs(days)} days`
                                                  : `Expires today`}
                                            </Label>
                                          );
                                        })()}
                                      </div>
                                    </Box>
                                  )
                                )}



                                <Box>
                                  <TextField
                                    fullWidth
                                    label={formData.gst_type == 1 ? "Business Address (As Per GST)" : "Address"}
                                    name={formData.gst_type == 1 ? "gst_business_address" : "l_address"}
                                    value={formData.gst_type == 1 ? formData?.gst_business_address || "" : formData?.l_address || ""}
                                    onChange={onChangeFunction}
                                    size="small"
                                    multiline
                                    minRows={2}
                                    margin="dense"
                                  />
                                </Box>

                                {/* GST Number Field */}
                                {formData.gst_type == 1 && (
                                  <Box>
                                    <TextField
                                      fullWidth
                                      autoComplete="off"
                                      type="text"
                                      label="GST No"
                                      name="gst_no"
                                      value={formData?.gst_no}
                                      onChange={(e) => {
                                        e.target.value = e.target.value.toUpperCase();
                                        onChangeFunction(e);
                                      }}
                                      onBlur={() => {
                                        setErrors({
                                          ...errors,
                                          gst_no: validateGST(formData?.gst_no)
                                        });
                                      }}
                                      helperText={errors.gst_no}
                                      error={errors.gst_no != "" ? true : false}
                                      size="small"
                                    />

                                    <Button
                                      variant="contained"
                                      size="small"
                                      sx={{ mt: 1 }}
                                      onClick={() => fetchGstDetailsbynumber(formData.gst_no)}
                                      disabled={!formData.gst_no || formData.gst_no.length !== 15}
                                    >
                                      Verify GST No
                                    </Button>
                                  </Box>
                                )}
                              </Stack>
                            </Grid>

                            {/* GST Helper Text - Full Width */}
                            {formData.gst_type == 1 && (
                              <Grid item xs={12}>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontSize: "12px",
                                    color: "#FF9800",
                                    display: "block",
                                    textAlign: "center"
                                  }}
                                >
                                  Invoice will be issued as per the provided GST number; otherwise,
                                  it will be billed in your business name, After that, no changes
                                  will be accepted
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                        </>
                      ) : null}
                    </Grid>
                  </div>
                  <div
                    style={{
                      margin: "10px auto",
                      display: "flex",
                      justifyContent: "center"
                    }}
                  >
                    {activeTab == 1 && (
                      <Button
                        variant="contained"
                        style={{ marginRight: "15px" }}
                        disabled={isLoading}
                        onClick={generateMemberInvoice}
                      >
                        Generate Invoice{" "}
                        {isLoading && (
                          <CircularProgress size={14} color="inherit" sx={{ marginLeft: "10px" }} />
                        )}
                      </Button>
                    )}
                  </div>
                </Card>
              </Box>
            )}
          </ContentStyle>
        </Container>
      </Page>
    </>
  );
}
